import React, { useState, useEffect } from 'react';
import { IconPlus } from '@tabler/icons-react';
import CreateRool from './CreateRool';
import axios from 'axios';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import PackageForm from './PackageForm';
import { IconCircleCheckFilled } from "@tabler/icons-react";
import Icon from '@mdi/react';
import { mdiSort } from '@mdi/js';
import { IconArrowsSort, IconChevronDown, IconX, IconSearch } from '@tabler/icons-react'
import '../../MyInvitations/Events.css'
import { useAuth } from "../../../Context/store/context";
import globals from '../../../../globals';
import ImageCropping from '../../../Common/Image/ImageCropping';
const Package = () => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [selectedRoolId, setSelectedRoolId] = useState(null);
  const [roolSection, setRoolSection] = useState([]);
  const [filterBy, setFilterBy] = useState("all");
  const [filteredData, setFilteredData] = useState([]);
  const [data, setData] = useState([]);
  const [sectionfilteredData, setSectionFilteredData] = useState([]);
  const { showLoader, hideLoader, getToken, updateTitleAndIcon, logoutuser } = useAuth();
  useEffect(() => {
    if (!getToken())
      logoutuser();
    updateTitleAndIcon(globals.Package.title, globals.Package.icon);
  }, []);
  const toggleDialog = (packageId = null) => {
const matchedRool = data.find((rool) => rool.packageId === packageId);
setSelectedRoolId(matchedRool)
    setIsDialogOpen(true);
  };
  const closeDialog = () => {
    setIsDialogOpen(false);
    setSelectedRoolId(null);
    fetchRools();
  };
  const fetchRools = async () => {
    try {
      const response = await axios.get(`http://localhost:4000/getadminpackage`);
      console.log(response.data.Rool);

      if (Array.isArray(response.data.Rool)) {
        setRoolSection(response.data.Rool);
      } else {
        setRoolSection([]); // Ensure it's always an array
      }
    } catch (error) {
      console.error('Error fetching rools:', error);
      setRoolSection([]); // Handle error case
    }
  };




  const handleFilter = (website) => {
    const filtered = roolSection.filter(item => item.website === website);
    setFilteredData(filtered);

    setFilterBy(website);
  };

  const handleSectionFilter = (type) => {
    console.log("type", type);
    if (type === "all") {
      setSectionFilteredData(filteredData); // Show all data based on selected website
    } else if (filteredData.length === 0) {
      // If no website filter is applied, filter from the main roolSection
      const filtered = roolSection.filter(item => item.packagetype === type);
      setSectionFilteredData(filtered);
    } else {
      // If a website filter is applied, filter from the filteredData
      const filtered = filteredData.filter(item => item.packagetype === type);
      setSectionFilteredData(filtered);
    }
    setFilterBy(type);
  };


  console.log("sectionfilteredData", sectionfilteredData)
  useEffect(() => {
    if (sectionfilteredData.length > 0) {
      setData(sectionfilteredData);
    } else {
      setData(roolSection);
    }
  }, [roolSection, sectionfilteredData]);

  console.log("data", data)
  const [searchValue, setSearchValue] = useState("");
  const [sortedData, setSortedData] = useState(data);
  const resetHandler = () => setSearchValue("");
  const searchHandler = () => {
    const filtered = data.filter(item =>
      item.Name.toLowerCase().includes(searchValue.toLowerCase())
    );
    setData(filtered);
  };
  const handleSort = (order, type) => {
    const sorted = [...data].sort((a, b) => {
      if (type === "name") {
        return order === "asc" ? a.Name.localeCompare(b.Name) : b.Name.localeCompare(a.Name);
      } else if (type === "price") {
        return order === "asc" ? a.price - b.price : b.price - a.price;
      }
      return 0;
    });
    setSortedData(sorted);
  };
  

  
  const handleDeleteData = async (packageId) => {
    try {
      const matchedRool = data.find((rool) => rool.packageId === packageId);
      console.log("matchedRool", matchedRool.packageId);
  
      const response = await axios.delete(`http://localhost:4000/getpackagedelete/${matchedRool.packageId}`);
      console.log(response.data.message);
      fetchRools();
    } catch (error) {
      console.error('Error deleting role:', error);
    }
  };
        const [application, setApplication] = useState([]);
  
  const fetchapplication = async () => {
    try {
      const response = await axios.get(`http://localhost:4000/getapplication`);
      console.log(response.data.application);

      if (Array.isArray(response.data.application)) {
        setApplication(response.data.application);
      } else {
        setApplication([]); // Ensure it's always an array
      }
    } catch (error) {
      console.error('Error fetching rools:', error);
      setApplication([]); // Handle error case
    }
  };
  useEffect(() => {
    fetchRools();
    fetchapplication();
  }, []);
  return (
    <div style={{ padding: "2%" }}>
      <div >

        <div className="card mb-3 ">
          <div className="card-body d-flex align-items-center flex-wrap">
            <div className="flex-grow-1 d-flex flex-wrap">
              <div className="flex-grow-1 flex-shrink-0 search me-1">
                <div className="search-input-wrap w-100 md-w-75">
                  <input className="search-input w-100 p-2" placeholder="Search by package name" value={searchValue} onChange={(e) => setSearchValue(e.target.value)} />
                  {searchValue && searchValue != "" &&
                    <IconX size={16} className="search-clear" onClick={resetHandler} />
                  }
                </div>
                <button className="btn btn-soft-primary search-btn me-1" onClick={searchHandler}><IconSearch size={16} /></button>
              </div>
            </div>
            <div className="ms-1 ms-md-5">
              <div className="dropdown" data-bs-toggle="dropdown">
                <div aria-haspopup="true" className="" aria-expanded="false" style={{ width: "max-content" }}>
                  <button className="btn btn-outline-primary py-0 me-0 me-md-2 py-md-2 d-flex">
                    <Icon path={mdiSort} className="d-block d-md-none" style={{ width: "1.5rem", height: "2rem" }} />
                    <div className="d-none d-md-block">Sort By</div>
                    <IconChevronDown size={18} className="d-none d-md-block" />
                  </button>
                </div>
                <div role="menu" className="px-1 px-md-3 dropdown-menu">
                  <b>Name</b>
                  <button type="button" className="dropdown-item" onClick={() => handleSort("asc","name")}>
            A - Z
          </button>
          <button type="button" className="dropdown-item" onClick={() => handleSort("desc","name")}>
            Z - A
          </button>
                  <hr />
                  <b>Price</b>
                  <button type="button" className="dropdown-item" onClick={() => handleSort("asc","price")}>low - high</button>
                  <button type="button" className="dropdown-item" onClick={() => handleSort("desc","price")}>high - low</button>
           </div>
              </div>
            </div>
            <div className="ms-1">
              <div className="dropdown" data-bs-toggle="dropdown">
                <div aria-haspopup="true" className="" aria-expanded="false" style={{ width: "max-content" }}>
                  <button className="btn btn-outline-primary py-0 me-0 me-md-2 py-md-2 d-flex">
                    <Icon path={mdiSort} className="d-block d-md-none" style={{ width: "1.5rem", height: "2rem" }} />
                    <div className="d-none d-md-block">Application</div>
                    <IconChevronDown size={18} className="d-none d-md-block" />
                  </button>
                </div>
                <div role="menu" className="px-1 px-md-3 dropdown-menu">
                  <button type="button" className="dropdown-item" onClick={() => handleFilter("Invitd")}>Invitd</button>
                  <button type="button" className="dropdown-item" onClick={() => handleFilter("Photopoint")}>Photo Point</button>
                </div>
              </div>
            </div>
            <button className="btn btn-primary align-middle" onClick={toggleDialog}>
              <IconPlus className="me-sm-1 me-0" size={20} />
              Create
            </button>
          </div>
        </div>
      </div>

      <div className="d-flex flex-row mt-4 w-100 justify-content-center mb-5">
        <div role="group" className="period-container btn-group">
          {["all", "Package", "AddOn"].map((filter) => (
            <div key={filter} className="period d-flex flex-column align-items-center gap-2">
              <button
                type="button"
                className={`btn btn-outline-primary ${filterBy === filter ? "selected" : ""}`}
                onClick={() => handleSectionFilter(filter)}
              >
                {filter === "all" ? "All" : filter}
              </button>
            </div>
          ))}
        </div>
      </div>



      <div className="content-wrapper">
        <div className="container-xxl flex-grow-1 container-p-y">
          <div className="d-flex flex-column gap-0 mp-2 rounded justify-content-center align-items-center">
            <div className="w-100 mb-4">
              <div className="w-100 gap-4 gap-md-0 justify-content-start mb-3 row">
              {(sortedData && sortedData.length > 0 ? sortedData : data).map((item, index) => (
  <div key={index} className="fotoowl-plan col-md-6 col-xl-3">
    <div className={"main-card h-100 position-relative card"}>
      <div className="px-1 card-header">
        <div className="d-flex justify-content-start">
          <img src="/images/card-advance-sale.png" height="60px" />
          <div className="d-flex flex-column justify-content-center align-items-start pt-1 mx-2">
            <strong className="text-uppercase">{item.Name}</strong>
            <div className="mb-0">
              <div>
                {item.offerprice && (
                  <div className="d-flex">
                    <div className="before-discount-price">₹ {item.offerprice} </div>
                  </div>
                )}
                <div className="d-flex align-items-end flex-wrap">
                  <h3 className="mb-0">₹ {item.price} </h3>
                </div>
              </div>
              <span>Validity: {item.Validity}{item.Validation}</span>
            </div>
          </div>
        </div>
      </div>
      <div className="px-1 px-md-3 card-body">
        <div>
          <h4>
            <strong>Includes</strong>
          </h4>
        </div>
        <div className="d-flex flex-column align-items-start gap-2">
          {[{ label: "invitationCount", value: item.invitationCount, name: "InvitationCount" },
            { label: "imageCount", value: item.imageCount, name: "ImageCount" },
            { label: "videoCount", value: item.videoCount, name: "VideoCount" },
            { label: "maxImageCount", value: item.maxImageCount, name: "MaxImageCount" }].map((offer, i) =>
            offer.value ? (
              <div key={i} style={{ fontSize: "0.85rem" }}>
                <IconCircleCheckFilled className="me-1 text-primary align-middle" size={17} />
                {offer.name}: {offer.value}
              </div>
            ) : null
          )}
        </div>
        {!item.invitationCount && (
          <div className="d-flex flex-column align-items-start gap-2">
            {[{ label: "drive", value: item.drive, name: "Drive" },
              { label: "storage", value: item.storage, name: "Storage" }].map((feature, i) =>
              feature.value ? (
                <div key={i} style={{ fontSize: "0.85rem" }}>
                  <IconCircleCheckFilled className="me-1 text-primary align-middle" size={17} />
                  {feature.name}: {feature.value}
                </div>
              ) : null
            )}
          </div>
        )}
      </div>
      <div className="modal-footer gap-2">
          <button type="submit"  className="btn btn-secondary"   
          onClick={() => toggleDialog(item.packageId)} >Edit</button>
          <button className="btn btn-primary"  onClick={() => handleDeleteData(item.packageId)} >Delete</button>
        </div>
     
    </div>
  </div>
))}

                
              </div>
            </div>
          </div>
        </div>
      </div>
     
      {isDialogOpen && (
        <PackageForm name={selectedRoolId} onClose={closeDialog} />

      )}
    </div>
  )
}

export default Package






















